import { z } from "zod";

export const passwordSchema = z
	.string()
	.min(8, "パスワードは8文字以上で入力してください");
// .regex(
// 	/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/,
// 	"パスワードは英字と数字を含む必要があります",
// );
